import Reveal from '@/components/feature/Reveal';
import { commercial } from '@/mocks/services';
import { site } from '@/data/site';

export default function Commercial() {
  return (
    <section
      id="gewerbe"
      className="relative bg-primary-950 py-20 md:py-28 scroll-mt-24 overflow-hidden"
    >
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-accent-500/60 to-transparent" />
      <div className="absolute inset-0 opacity-[0.08] bg-[radial-gradient(circle_at_18%_20%,oklch(var(--accent-500))_0,transparent_42%),radial-gradient(circle_at_88%_75%,oklch(var(--secondary-400))_0,transparent_38%)]" />

      <div className="relative w-full px-4 md:px-8">
        <div className="lg:flex lg:items-end lg:justify-between lg:gap-12">
          <Reveal className="lg:max-w-2xl">
            <span className="inline-flex items-center gap-2 font-label text-xs font-semibold uppercase tracking-[0.32em] text-accent-400">
              <span className="w-6 h-px bg-accent-500" />
              Für Gewerbekunden
            </span>
            <h2 className="mt-5 font-heading text-3xl md:text-5xl font-semibold leading-tight text-background-50">
              {commercial.title}
            </h2>
          </Reveal>
          <Reveal variant="right" className="lg:max-w-md mt-6 lg:mt-0">
            <p className="font-body text-base leading-relaxed text-background-100/75">
              {commercial.intro}
            </p>
          </Reveal>
        </div>

        <Reveal className="mt-10">
          <div className="flex flex-wrap gap-2.5">
            {commercial.targets.map((target) => (
              <span
                key={target.label}
                className="inline-flex items-center gap-2 rounded-full border border-accent-500/25 bg-background-50/[0.05] px-4 py-2 font-label text-sm text-background-100 whitespace-nowrap transition-colors hover:border-accent-500/60 hover:bg-background-50/[0.09]"
              >
                <i className={`${target.icon} text-accent-400`} />
                {target.label}
              </span>
            ))}
          </div>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-5">
          {commercial.promises.map((promise, index) => (
            <Reveal key={promise.title} delay={index * 110} className="h-full">
              <article className="group h-full rounded-xl border border-background-50/12 bg-background-50/[0.04] p-6 md:p-7 transition-all duration-500 hover:-translate-y-1.5 hover:border-accent-500/50 hover:bg-background-50/[0.08]">
                <div className="w-12 h-12 rounded-md bg-accent-500 flex items-center justify-center transition-transform duration-500 group-hover:scale-110">
                  <i className={`${promise.icon} text-2xl text-foreground-950`} />
                </div>
                <h3 className="mt-5 font-heading text-lg md:text-xl font-semibold text-background-50">
                  {promise.title}
                </h3>
                <p className="mt-2.5 font-body text-sm leading-relaxed text-background-100/70">
                  {promise.text}
                </p>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal className="mt-10 flex flex-col sm:flex-row sm:items-center gap-4">
          <a
            href="#kontakt"
            className="inline-flex w-fit items-center gap-2 rounded-md bg-accent-500 hover:bg-accent-400 text-foreground-950 font-label font-bold text-base px-7 py-4 transition-all duration-300 hover:-translate-y-0.5 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-mail-send-line text-lg" />
            Objekt anfragen
          </a>
          <span className="font-label text-sm text-background-100/65">
            oder direkt anrufen:{" "}
            <a href={site.phoneHref} className="text-accent-400 underline cursor-pointer">
              {site.phoneDisplay}
            </a>
          </span>
        </Reveal>
      </div>
    </section>
  );
}